import { gql } from '@apollo/client';

export const updateOrganisationUserMutation = gql`
  mutation ($pk_columns: users_organisation_admin_pk_columns_input!, $set: users_organisation_admin_set_input!) {
    update_users_organisation_admin_by_pk(pk_columns: $pk_columns, _set: $set) {
      id
    }
  }
`;
